import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import IngredientServices from "./IngredientServices";

const initialState = {
  ingredient: null,
  ingredients: [],
  isError: false,
  isSuccess: false,
  isSuccessCreateUpdate: false,
  isLoading: false,
  message: "",
};

// createIngredient thunkApi
export const createIngredient = createAsyncThunk(
  "ingredient/createIngredient",
  async (ingredientData, thunkAPI) => {
    try {
      return await IngredientServices.createIngredient(ingredientData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIngredients = createAsyncThunk(
  "ingredient/getIngredients",
  async (_, thunkAPI) => {
    try {
      return await IngredientServices.getIngredients();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIngredient = createAsyncThunk(
  "ingredient/updateIngredient",
  async (ingredientData, thunkAPI) => {
    try {
      return await IngredientServices.updateIngredient(ingredientData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteIngredient = createAsyncThunk(
  "ingredient/deleteingredient",
  async (id, thunkAPI) => {
    try {
      return await IngredientServices.deleteIngredient(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const ingretientSlice = createSlice({
  name: "ingredient",
  initialState,
  reducers: {
    RESET_INGREDIENT(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isSuccessCreateUpdate = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // create ingredient
      .addCase(createIngredient.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createIngredient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreateUpdate = true;
        state.ingredient = action.payload;
        toast.success("Create new ingredient successfully");
      })

      .addCase(createIngredient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.ingredient = null;
        toast.error(action.payload);
      })

      .addCase(getIngredients.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getIngredients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.ingredients = action.payload.data;
      })

      .addCase(getIngredients.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.ingredients = null;
        toast.error(action.payload);
      })

      .addCase(updateIngredient.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateIngredient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreateUpdate = true;
        state.ingredient = action.payload.data;
        toast.success(action.payload.message);
      })

      .addCase(updateIngredient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.ingredient = null;
        toast.error(action.payload);
      })

      .addCase(deleteIngredient.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteIngredient.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.ingredient = null;
        toast.success(action.payload);
      })

      .addCase(deleteIngredient.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.ingredient = null;
        toast.error(action.payload);
      });
  },
});

export const { RESET_INGREDIENT } = ingretientSlice.actions;
export const selectIngredient = (state) => state.ingredient.ingredient;
export const selectIngredients = (state) => state.ingredient.ingredients;
export const selectIngredientSuccess = (state) => state.ingredient.isSuccess;
export const selectIngredientSuccessCreateUpdate = (state) =>
  state.ingredient.isSuccessCreateUpdate;

export default ingretientSlice.reducer;
